import { Injectable } from '@angular/core';
import { NavigationConfigService } from './navigation-config.service';
declare global {
  interface Window {
    plausible?: (eventName: string, options?: { props?: Record<string, any> }) => void;
  }
}
@Injectable({
  providedIn: 'root'
})
export class PlausibleAnalyticsService {
  private allowedRoles = ['HMGR', 'HAPPR', 'HEXCT', 'HRL', 'HRN', 'HRLN'];

  constructor(private navConfigService: NavigationConfigService) { }

  trackPageview(currentRoute: string, userRole: string): void {

    if (!this.allowedRoles.includes(userRole)) {
      return;
    }

    // Reads the cached, role-scoped navigation config instead of the retired
    // src/data/ValidRouts.ts. Cache-only on purpose: analytics must never trigger an
    // API call, and a cold cache simply means no pageview is recorded. By the time a
    // page has rendered, authRouteGuard has already populated it.
    const navConfig = this.navConfigService.getConfigSync();

    if (!navConfig) {
      return;
    }

    if (!navConfig.routes.includes(currentRoute)) {
      return;
    }

    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible('pageview', {
        props: { route: currentRoute, role: userRole }
      });
    }
  }

  trackEvent(eventName: string, props?: Record<string, any>): void {
    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible(eventName, { props });
    }
  }
}
